import React, { useState } from 'react';

const useSetting = () => {
  const keys = ["platform", "interest", "services", "outputStatus", "videoCategories"];
  const [selectedKey, setSelectedKey] = useState("platform");
  const handleSelect = (keys: string) => {
    setSelectedKey(keys);
  };
  return { keys, handleSelect, selectedKey };
};
export default useSetting;
